module.exports = __webpack_public_path__ + "img/work.68406879.svg";